import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['searchInput', 'ownersList']

  declare readonly searchInputTarget: HTMLInputElement
  declare readonly ownersListTarget: HTMLElement

  filter (): void {
    const searchTerm = this.searchInputTarget.value.toLowerCase().trim()
    const ownerElements = this.ownersListTarget.querySelectorAll<HTMLElement>('[data-owner-name]')

    ownerElements.forEach((element) => {
      const ownerName = element.dataset.ownerName ?? ''
      if (ownerName !== '' && ownerName.includes(searchTerm)) {
        element.classList.remove('hidden')
      } else {
        element.classList.add('hidden')
      }
    })
  }
}
